import { colors } from 'component-library/__styling/settings'
import { CSSObject } from '@emotion/css'

const boxshadowVertical = 2
const boxshadowHorizontal = 6
const boxshadowOffset = boxshadowHorizontal / 2

const getHeadlineBoxShadow = (isHover = false) => {
    const color = isHover ? colors.perthnow.blueSapphire : colors.perthnow.greyBasalt
    const horizontal = boxshadowHorizontal + 'px'
    const vertical = boxshadowVertical + 'px'

    return [
        // right and bottom
        `${horizontal} 0 ${color}`,
        `${horizontal} ${vertical} ${color}`,

        // left
        `${-boxshadowOffset + 'px'} 0 ${color}`,
        `${-boxshadowOffset + 'px'} ${vertical} ${color}`,
    ].join(', ')
}

export const headlineBoxshadow: CSSObject = {
    boxShadow: getHeadlineBoxShadow(true),
    boxDecorationBreak: 'clone',
}
